import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Modal from '@components/styled-UI/Modal';

import PreLoader from '@images/svg-icons/preLoader.svg';

import { RootState } from 'src/store/reducers';

import { getLabelFallback } from '@utils/utils';
import { IRetailOrderDetails, IRetailOrderHistory } from '@interfaces/myPurchasesInterfaces';
import {
    handleContactLensesReorder,
} from '@utils/pages-utils/MyPurchasesUtils';
import { useNavigate } from 'react-router-dom';
import { getStringFromDate } from '@utils/dateUtils';
import BoxImage from '@components/styled-UI/BoxImage';
import RetailOrder from '@images/svg-icons/retailPrescription.svg'
import PlaceHolderCL from '@images/svg-icons/placeholderImageCL.svg'
import PlaceHolderFrame from '@images/svg-icons/placeholderImageFrame.svg'
import PlaceHolderOther from '@images/svg-icons/placeholderImageOther.svg'
import InfoIcon from '@images/svg-icons/infoIcon.svg';
import lensImage from '@images/lens.png';
import { IAddToCartPayload } from '@interfaces/myAppointmentInterfaces';
import { addToBagService } from '@services/myAppointmentServices';
import { reorderContactRetailService } from '@services/myAppointmentServices';

interface Props {
    isOpenDeleteModal?: boolean;
    isSubmitting?: boolean;
    onModalSubmit?: () => void;
    onCloseModal?: () => void;
    order;
}

const WrapperSummaryRetail = ({
    isOpenDeleteModal = false,
    isSubmitting = false,
    onModalSubmit,
    onCloseModal,
    order,
}: Props): JSX.Element => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const [images, setImages] = useState(null);
    const [status, setStatus] = useState(null);
    const MAX_IMAGE = !isMobile ? 4 : 2;

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const isOrderStatusCompleted = order.orderStatus.toLowerCase().includes('dispensed')
    const [onlyOneIsNotBuyable, setOnlyOneIsNotBuyable] = useState(false);
    const [isAtLeastOneBuyable, setIsAtLeastOneBuyable] = useState(false);

    useEffect(() => {
        setStatus(order.orderStatus)
        const arrayOfBuyable = order.retailOrderDetails?.orderItems.filter(element => element.buyable === "true")
        if (arrayOfBuyable.length > 0) {
            setIsAtLeastOneBuyable(true)
        }

        const arrayOfContacts = order.retailOrderDetails?.orderItems.filter(element => element.productKind === "CONTACTS")
        if (arrayOfBuyable.length != 0 && arrayOfBuyable.length < arrayOfContacts.length) {
            setOnlyOneIsNotBuyable(true)
        }

        const arrayImages = order.retailOrderDetails?.orderItems.map(obj => ({
            imgUrl: obj.isOnlyLens ? lensImage : obj.productKind?.includes('FRAMES') || obj.productKind?.includes('SUN') || obj.productKind?.includes('CONTACTS') ? !!obj.isPublished && obj.isPublished.includes('true') ? obj.picture : null : obj.productKind?.includes('READERS') ? null : obj.picture,
            productPageUrl: obj.pdpLink,
            productKind: obj.productKind,
            isAtLeastOneBuyable: isAtLeastOneBuyable,
            buyable: !!obj.buyable && obj.buyable.includes('true') ? true : false,
        }));
        setImages(arrayImages)
    }, [images]);

    const navigateToOrderDetailsRetail = (orderId, storeDetails, orderDetails) => {
        const data = {
            store: storeDetails,
            order: orderDetails
        }
        navigate(`/order-retail/${orderId}`, { state: data })
    }

    const handleReorderContactsRetail = (retailOrderDetails: IRetailOrderDetails) => {
        const arrayOfContacts = retailOrderDetails.orderItems.filter(element => element.productKind === "CONTACTS" && element.buyable === "true");
        let rightLensId, leftLensId, boxOD, boxOS = null;

        if (arrayOfContacts.length === 1) {
            rightLensId = arrayOfContacts[0].catentryIdRight
            leftLensId = arrayOfContacts[0].catentryIdLeft
            boxOD = arrayOfContacts[0].quantityRight
            boxOS = arrayOfContacts[0].quantityLeft
        } else {
            if (arrayOfContacts[0].eyeCode === 'RIGHT') {
                rightLensId = arrayOfContacts[0].catentryIdRight
                leftLensId = arrayOfContacts[1].catentryIdLeft
                boxOD = arrayOfContacts[0].quantityRight
                boxOS = arrayOfContacts[1].quantityLeft
            } else {
                rightLensId = arrayOfContacts[1].catentryIdRight
                leftLensId = arrayOfContacts[0].catentryIdLeft
                boxOD = arrayOfContacts[1].quantityRight
                boxOS = arrayOfContacts[0].quantityLeft
            }
        }

        const payload: IAddToCartPayload = {
            isMockRequest: config.mockRequest,
            storeId: config.storeId,
            catalogId: config.catalogId,
            langId: config.langId.toString(),
            URL: 'GetCatalogEntryDetailsByID',
            errorViewName: 'LogonAjaxView',
            cache: false /* Must be always "false" */,
            action: 'add' /* Must be always "add" */,
            orderId: '.' /* Must be always "." */,
            partType: 'CONTACT_LENSES' /* Must be always "CONTACT_LENSES" */,
            leftLensItemId: leftLensId /* Left eye SKU id */,
            rightLensItemId: rightLensId /* Right eye SKU id */,
            leftQuantity: boxOS /* Left eye quantity  */,
            rightQuantity: boxOD /* Right eye quantity  */,
            leftPrescriptionId: null /* Left account prescription id */,
            rightPrescriptionId: null /* Right account prescription id */,
            autosetquantity: 'supplyAmount',
            isPrescriptionRetail: true,
            isReorderRetail: true,
            catEntryId: '',
            prescriptionId: retailOrderDetails?.prescription?.prescriptionId,
            prescriptionStore: retailOrderDetails?.store?.number,
            examExpireDate: retailOrderDetails?.prescription?.examExpireDate,
        };

        const analyticsPayload = mapOrderItemsAnalytics(retailOrderDetails);
        if (analyticsPayload) {
            window?.tealium_data2track?.push({
                "id": "Event",
                "Events_CartAdd": "1",
                "Products": analyticsPayload
            });
        }

        dispatch(reorderContactRetailService(config.storeId, config.catalogId, config.langId, payload));
    }

    const mapOrderItemsAnalytics = (orderItems: IRetailOrderDetails) => {
        let objects = {};
        let ordersContact = orderItems.orderItems.filter(element => element.productKind === "CONTACTS")
        if (orderItems.hasContactLenses && (orderItems.orderStatus.toLowerCase() === 'dispensed' || orderItems.orderStatus.toLowerCase() === 'delivered')) {
            ordersContact.forEach(item => {
                if(!!item.catentryIdRight){
                    objects[item.parentUpc] = {
                        "Status": !!item.isPublished && !!item.buyable ? "Available" : "Not-for-sale",
                        "Category": "CONTACT LENSES",
                        "LensType": "",
                        "Price": "0.00",
                        "PriceFull": "0.00",
                        "Units": Number(item.quantityRight).toString(),
                        "ModelName": item.frameName,
                        "Brand": item.brandName,
                        "ReorderSource": "Retail",
                        "Image": item.picture,
                        "Url": !!item.pdpLink ? window.location.origin + item.pdpLink : null
                    }
                }

                if(!!item.catentryIdLeft){
                    objects[item.parentUpc] = {
                        "Status": !!item.isPublished && !!item.buyable ? "Available" : "Not-for-sale",
                        "Category": "CONTACT LENSES",
                        "LensType": "",
                        "Price": "0.00",
                        "PriceFull": "0.00",
                        "Units": Number(item.quantityLeft).toString(),
                        "ModelName": item.frameName,
                        "Brand": item.brandName,
                        "ReorderSource": "Retail",
                        "Image": item.picture,
                        "Url": !!item.pdpLink ? window.location.origin + item.pdpLink : null
                    }
                }
            })

            return objects
        }
    }

    const rendereOrderHistoryButtons = (
        orderId: string,
        hasContactLenses: boolean,
        orderStatus: string,
        retailOrderDetails: IRetailOrderDetails
    ): JSX.Element => {
        return (
            <div
                role="region"
                aria-label="Online order history view details button"
                className={`${isMobile ? 'order-history-buttons' : 'mobile-order-history-buttons'}`}
            >
                {(hasContactLenses && config.enableReorderContactsRetail?.includes('true') && isAtLeastOneBuyable && (orderStatus.toLowerCase() === 'dispensed' || orderStatus.toLowerCase() === 'delivered')) && (
                    <button
                        className="primary-button button-size-small custom-mob"
                        data-element-id="OrderHistory_ReorderContacts"
                        onClick={() => { handleReorderContactsRetail(retailOrderDetails) }}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_REORDER_CONTACT_LENSES_CTA_LABEL'
                        )}
                    </button>
                )}
                <button
                    className="primary-button-negative button-size-small custom-mob"
                    data-element-id="OrderHistory_OrderDetails"
                    onClick={() => navigateToOrderDetailsRetail(orderId, order.store, order.retailOrderDetails)}
                >
                    {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_VIEW_DETAILS_CTA_LABEL')}
                </button>
            </div>
        );
    };

    const renderWrapperHeader = (order: IRetailOrderHistory): JSX.Element => {
        const { orderId, orderStatus, placedDate, retailOrderDetails } = order;
        return (
            <>
                <div className="wrapper-summary-icon-container">
                    <RetailOrder />
                    <span className="wrapper-summary-icon-container-text">{getLabelFallback('MYPROFILE_MY_ORDERS_RETAIL_LABEL')}</span>
                </div>
                <div
                    role="region"
                    aria-label="Online order history overview header"
                    className="wrapper-summary-header"
                >
                    <div className="wrapper-summary-header-order-number">
                        {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_NUMBER')?.replace(
                            '{ORDER_NUMBER}',
                            orderId
                        )}
                        <span className="wrapper-summary-header-date-order">
                            {getStringFromDate(new Date(placedDate), 'MM/dd/yyyy')}
                        </span>
                    </div>
                    {!isMobile &&
                        rendereOrderHistoryButtons(
                            orderId,
                            retailOrderDetails.hasContactLenses,
                            orderStatus,
                            retailOrderDetails
                        )}
                </div>
                {!isMobile && (orderStatus.toLowerCase() === 'delivered' || orderStatus.toLowerCase() === 'dispensed') && onlyOneIsNotBuyable && (
                    <div className="wrapper-summary-not-buyable">
                        <div>
                            <InfoIcon />
                        </div>
                        <span>{getLabelFallback('MYPROFILE_MY_ORDERS_RETAIL_WRAPPER_SUMMARY_NOT_BUYABLE')}</span>
                    </div>
                )}
            </>
        );
    };

    const renderProductImage = element => {
        return (
            <>
                {!!element.imgUrl && !element?.productKind?.includes('READERS') && (
                    <BoxImage
                        imageUrl={element.imgUrl}
                        fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
                        imageAlt="Product image"
                    />
                )}

                {!!element.imgUrl === false
                    && (element?.productKind?.includes('FRAMES') || element?.productKind?.includes('SUN') || element?.productKind?.includes('READERS'))
                    && (
                        <div className="placeholder-container frames">
                            <div className="icon-container">
                                <PlaceHolderFrame />
                            </div>
                            <div className="text-container">
                                <span className='text-container-bold'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_EYEWEAR')}</span>
                                <span className='text-container-standard'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT')}</span>
                            </div>
                        </div>
                    )}

                {!!element.imgUrl === false && element?.productKind?.includes('CONTACTS') && (
                    <div className="placeholder-container contact">
                        <div className="icon-container">
                            <PlaceHolderCL />
                        </div>
                        <div className="text-container">
                            <span className='text-container-bold'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_CONTACT')}</span>
                            <span className='text-container-standard'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT')}</span>
                        </div>
                    </div>
                )}

                {!!element.imgUrl === false
                    && (element?.productKind?.includes('ACCESSORIES') || element?.productKind?.includes('APPAREL') || element?.productKind?.includes('LENSES') || element?.productKind?.includes('OTHER'))
                    && (
                        <div className="placeholder-container others">
                            <div className="icon-container">
                                <PlaceHolderOther />
                            </div>
                            <span className='text-container-standard'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT')}</span>
                        </div>
                    )}
            </>
        );
    };

    const renderWrapperBody = (order: IRetailOrderHistory): JSX.Element => {
        const {
            orderId,
            grandTotal,
            orderStatus,
            retailOrderDetails,
        } = order;

        return (
            <div className="wrapper-summary-content-body">
                <div
                    role="region"
                    aria-label="Online order history overview body"
                    className="wrapper-summary-content-online-order"
                >
                    <div className="wrapper-summary-content-label">
                        {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_LABEL')}
                    </div>
                    <div
                        className={
                            'wrapper-summary-content-value formatted' +
                            (orderStatus.toLowerCase() === 'shipped' ? ' two-line' : '')
                        }
                    >
                        {getLabelFallback(
                            orderStatus.toLowerCase().includes('order receive')
                                ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_ORDER_RECEIVE'
                                : orderStatus.toLowerCase() === 'in process'
                                    ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_IN_PROCESS'
                                    : orderStatus.toLowerCase() === 'shipped'
                                        ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                        : orderStatus.toLowerCase() === 'ready for pickup'
                                            ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                            : orderStatus.toLowerCase() === 'dispensed'
                                                ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                                : orderStatus.toLowerCase() === 'please call the store'
                                                    ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_PLEASE_CALL_THE_STORE'
                                                    : orderStatus.toLowerCase() === 'delivered'
                                                        ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                                        : orderStatus.toLowerCase() === 'returned'
                                                            ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_RETURNED'
                                                            : orderStatus.toLowerCase() === 'in progress'
                                                                ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_IN_PROCESS'
                                                                : ''
                        ).replace("${storeNumber}", retailOrderDetails.store.number)}
                    </div>
                    <div className="wrapper-summary-content-label">
                        {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_TOTAL_LABEL')}
                    </div>
                    <div className="wrapper-summary-content-value">{`$ ${Number(grandTotal).toFixed(2)
                        }`}</div>
                    <div className="wrapper-summary-content-label">
                        {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_STORE_LABEL')}
                    </div>
                    <div className="wrapper-summary-content-value store two-line">
                        {retailOrderDetails.store.storeName},
                        {' ' + retailOrderDetails.store.address},
                        {' ' + retailOrderDetails.store.city}
                        <div className='link-containers'>
                            <a href={`http://maps.google.com/?q=${encodeURIComponent(retailOrderDetails?.store?.address + ' ' + retailOrderDetails?.store?.city + ' ' + retailOrderDetails?.store?.country + ' ' + retailOrderDetails?.store?.postalCode)}`} target="_blank">Get directions</a>
                            <a href={`${config.visitStoreUrl + retailOrderDetails?.store?.number}`} target="_blank">Visit store page</a>
                        </div>
                    </div>
                </div>
                {images && (
                    <div
                        role="region"
                        aria-label="Online order history overview body image"
                        className="wrapper-summary-content-body-images"
                    >
                        {images.map((element, index) => {
                            if (index <= MAX_IMAGE - 1) {
                                return (
                                    <div
                                        className={
                                            'wrapper-summary-content-body-images-inner number-' +
                                            index +
                                            (index === MAX_IMAGE - 1 ? ' last-element' : '') +
                                            (element.productKind === "CONTACTS" && !element.buyable ? orderStatus.toLowerCase() === 'delivered' ? ' not-buyable' : orderStatus.toLowerCase() === 'dispensed' ? ' not-buyable' : '' : '')
                                        }
                                    >
                                        {(orderStatus.toLowerCase() === 'delivered' || orderStatus.toLowerCase() === 'dispensed') && element.productKind === "CONTACTS" && !element.buyable && (
                                            <>
                                                <div className='not-buyable-case'>Not available</div>
                                            </>
                                        )}
                                        {!!element?.productPageUrl ? (
                                            <a href={element?.productPageUrl}>
                                                {renderProductImage(element)}
                                            </a>
                                        ) : (
                                            renderProductImage(element)
                                        )}
                                        {index === MAX_IMAGE - 1 && images.length > MAX_IMAGE && (
                                            <div className="overlay-number">
                                                +{' ' + (images.length - MAX_IMAGE)}
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                        })}
                    </div>
                )}
            </div>
        );
    };

    const renderWrapperFooter = (retailOrderDetails: IRetailOrderDetails): JSX.Element => {
        return (
            <div
                role="region"
                aria-label="Online order history overview footer"
                className="wrapper-summary-footer"
            >
                <div className="primary-message medium align-left">
                    {getLabelFallback(
                        'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_1_SUGGEST'
                    )}
                    <a
                        href={`${config.visitStoreUrl + retailOrderDetails?.store?.number}`}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER'
                        )}
                    </a>
                    {getLabelFallback(
                        'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_2_SUGGEST'
                    )}
                    <a
                        href={'/to-us/returns'}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER_RETURN'
                        )}
                    </a>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="wrapper-summary">
                {renderWrapperHeader(order)}
                <div className="wrapper-summary-separator"></div>
                {renderWrapperBody(order)}
                {isMobile && (order.orderStatus.toLowerCase() === 'delivered' || order.orderStatus.toLowerCase() === 'dispensed') && onlyOneIsNotBuyable && (
                    <div className="wrapper-summary-not-buyable">
                        <div>
                            <InfoIcon />
                        </div>
                        <span>{getLabelFallback('MYPROFILE_MY_ORDERS_RETAIL_WRAPPER_SUMMARY_NOT_BUYABLE')}</span>
                    </div>
                )}
                {isMobile &&
                    rendereOrderHistoryButtons(
                        order.orderId,
                        order.retailOrderDetails.hasContactLenses,
                        order.orderStatus,
                        order.retailOrderDetails
                    )}
                {isOrderStatusCompleted && renderWrapperFooter(order.retailOrderDetails)}
            </div>
            <Modal
                isOpen={isOpenDeleteModal}
                close={onCloseModal}
                isCentered
                showCloseIcon={!isMobile}
                customStyle={isMobile ? 'eye-exams-modal-sm' : 'eye-exams-modal'}
            >
                <div className="eye-exams-delete-modal">
                    <div className="message">
                        {getLabelFallback('MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_MESSAGE')}
                    </div>
                    <div className="buttons-container">
                        <button
                            data-element-id="BookAnAppointmentOverlay_Cancel"
                            data-description="Confirm"
                            className={`primary-button button-size-medium ${isSubmitting ? 'loading' : ''
                                }`}
                            onClick={onModalSubmit}
                        >
                            {getLabelFallback(
                                'MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_CONFIRM_CTA_LABEL'
                            )}
                            {isSubmitting && <PreLoader />}
                        </button>
                        <button
                            data-element-id="BookAnAppointmentOverlay_Cancel"
                            data-description="Keep"
                            className="primary-button-negative button-size-medium"
                            onClick={onCloseModal}
                        >
                            {getLabelFallback(
                                'MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_CANCEL_CTA_LABEL'
                            )}
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default WrapperSummaryRetail;
